import { Injectable } from '@angular/core';

export interface IParsedAddress {
  streetNumber?: string;
  streetName?: string;
  city: string;
  province: string;
  postalCode?: string;
  country?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AddressParserService {
  parseCanadianAddress(fullAddress: string): IParsedAddress | null {
    if (!fullAddress) return null;

    try {
      // Supprimer les espaces en trop et diviser par les virgules
      const parts = fullAddress.trim().split(',').map(part => part.trim());

      if (parts.length < 3) return null;

      // Partie 1: Numéro et nom de rue
      const streetPart = parts[0];
      const streetMatch = streetPart.match(/^(\d+)\s+(.+)$/);

      // Partie 2: Ville
      const city = parts[1];

      // Partie 3: Province + Code postal (et éventuellement pays)
      const provincePostalPart = parts[2];
      let country = parts[3] || '';

      // Parser province et code postal
      // Format Québec: "Québec J6N0T9" ou "Quebec J6N 0T9"
      const provincePostalMatch = provincePostalPart.match(/^(.+?)\s+([A-Z]\d[A-Z]\s?\d[A-Z]\d)$/);

      if (!provincePostalMatch) {
        // Si pas de code postal détecté, tout est considéré comme province
        return {
          streetNumber: streetMatch?.[1],
          streetName: streetMatch?.[2],
          city: city,
          province: provincePostalPart,
          country: country
        };
      }

      return {
        streetNumber: streetMatch?.[1],
        streetName: streetMatch?.[2],
        city: city,
        province: provincePostalMatch[1],
        postalCode: provincePostalMatch[2],
        country: country
      };

    } catch (error) {
      console.error('Erreur lors du parsing de l\'adresse:', error);
      return null;
    }
  }

  formatFullAddress(address: IParsedAddress): string {
    const parts: string[] = [];

    if (address.streetNumber && address.streetName) {
      parts.push(`${address.streetNumber} ${address.streetName}`);
    }

    parts.push(address.city);

    if (address.postalCode) {
      parts.push(`${address.province} ${address.postalCode}`);
    } else {
      parts.push(address.province);
    }

    return parts.join(', ');
  }

  formatShortAddress(address: IParsedAddress): string {
    return `${address.city}, ${address.province}`;
  }

  getFallbackAddress(fullAddress: string): string {
    const parts = fullAddress.split(',').map(p => p.trim());

    if (parts.length >= 3) {
      // Prendre ville (partie 2) et début de partie 3 (province)
      const city = parts[1];
      const provinceSection = parts[2].split(' ')[0]; // Premier mot de la section province/postal
      return `${city}, ${provinceSection}`;
    }

    return 'Région non spécifiée';
  }
}

